// extracted by mini-css-extract-plugin
export default {"Buttons":"duplicate-modal-module_Buttons_JT8Xi"};